let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lDFU4")).then(() => parcelRequire('719qB'));